import { useEdecidePanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const EdecideRunResult: React.FC = () => {
  const i18n = useTranslations();
  const { runResult } = useEdecidePanel();

  if (!runResult) return null;

  if (runResult.success) {
    return (
      <div>
        <h2>{i18n.EdecidePanel_CreateRun_Success}</h2>
        <span>
          <a href={runResult.runManagementUrl} target="_blank" className="sbb-link" rel="noreferrer">
            {i18n.Edecide_RunManagementUrl}
          </a>
          <br />
          <a href={runResult.runUrl} target="_blank" className="sbb-link" rel="noreferrer">
            {i18n.Edecide_RunUrl}
          </a>
        </span>
      </div>
    );
  }

  switch (runResult.responseStatusName) {
    case "NotFound":
      return <span>{i18n.EdecidePanel_CreateRun_Failure_NotFound}</span>;
    default:
      return <span>{i18n.EdecidePanel_CreateRun_Failure}</span>;
  }
};
